import { Component } from '@angular/core';

@Component({
	selector: 'report-header',
	templateUrl: './report-header.component.html',
	styleUrls: ['./report-header.component.scss']
})
export class ReportHeaderComponent {}
